import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Clickup = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 24"
    {...props}
  >
    <g clipPath="url(#clickup_clip0)">
      <path
        id="clickup_layer_5_"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="hsl(from hsl(249 79% 67%) h s 50%)"
        d="M1.5,18.5l3.7-2.8c2,2.6,4.1,3.8,6.4,3.8c2.3,0,4.3-1.2,6.2-3.7l3.8,2.8
	c-2.7,3.6-6.1,5.6-10,5.6C7.7,24,4.3,22.1,1.5,18.5z"
      />
      <path
        id="clickup_layer_4_"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="hsl(from hsl(249 79% 67%) h s 50%)"
        d="M11.3,6.2l-6.6,5.7l-3-3.5L11.3,0l9.6,8.3l-3.1,3.5L11.3,6.2z"
      />
    </g>
    <defs>
      <clipPath id="clickup_clip0">
        <rect x="1.5" y="0" width="20" height="24" />
      </clipPath>
    </defs>
  </svg>
);
